var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards-content"},_vm._l((_vm.content),function(item,index){return _c('fcwpSidebarCard',{key:index,staticClass:"card",class:item.data && item.data.image_url ? 'card-big' : 'card-small',attrs:{"card":item.data}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }